export default __webpack_public_path__ + "img/ezJmNnMB.f8141135.svg";